/** @format */

import { Breadcrumb } from "antd";
import { UICol, UIRow, UITitle, UITransition } from "@rstore-react-packages/template-ui";
import { NavLink } from "react-router-dom";
import { Routes } from "../../../utils/Routes";
import { useLanguage } from "../../../redux-modules/hooks/useLanguage";
import { useGenericAlert } from "../../../redux-modules/hooks/useGenericAlert";
import LayoutBranchesTable from "../../layout/Tables/Branches";
import { useSelector } from "react-redux";
import { selectorCustomerSelected } from "../../../redux-modules/selectors/selectorsUI";
import { LayoutCustomerMenu } from "../../layout/Menu/CustomerMenu";

const ViewBranch = (): JSX.Element => {
  //@ts-ignore

  const Alert = useGenericAlert(6000);

  const l = useLanguage();
  const customer = useSelector(selectorCustomerSelected);

  return (
    <>
      <LayoutCustomerMenu />
      <UITransition>
        {Alert}
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>
            <NavLink to={Routes.home}>Home</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <NavLink to={Routes.customer.replace(":id", `${customer?.id}`)}>
              {customer?.name}
            </NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Branches</Breadcrumb.Item>
        </Breadcrumb>
        <UIRow style={{ marginTop: "35px" }}>
          <UICol xs={24}>
            <UITitle level={3}>{l("branches")}</UITitle>
          </UICol>
        </UIRow>
        <LayoutBranchesTable
          filteredByCustomer={customer?.id}
          onSelect={(e): void => console.log(e)}
        />
      </UITransition>
    </>
  );
};

export default ViewBranch;
